import React from 'react'

const Divider = props => (
  <svg width={props.width} height={props.height} viewBox="0 0 28 8" {...props}>
    <title>Divider</title>
    <g fill={props.color} fillRule="evenodd">
      <ellipse cx={3.957} cy={4} rx={3.957} ry={4} />
      <ellipse cx={23.739} cy={4} rx={3.957} ry={4} />
      <path d="M6.168 1.6c5.021 2.186 10.021 2.222 15 .107l.115 4.118c-4.913-1.806-9.951-1.841-15.115-.106-5.164 1.735-5.164.362 0-4.119z" />
    </g>
  </svg>
)

Divider.defaultProps = {
  height: '8',
  width: '28',
  color: '#636569',
}

export default Divider



// WEBPACK FOOTER //
// ./src/svgs/Divider.js